import { getBabbelBaseUrl } from './url';

const discoverDeeplinkUrl = (learnLanguageAlpha3, locale) =>
  `${getBabbelBaseUrl()}/deeplinks/${locale}/learn_languages/${learnLanguageAlpha3}/discover`;

export default discoverDeeplinkUrl;
